import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ClickOutsideModule } from 'ng-click-outside';
import { CreditOptions, CREDIT_BANKS, HTTPSearchResultTour } from 'src/app/models';
import {PriceFormatPipe} from "../../../pipes/price-format/price-format.pipe";

@Component({
  selector: 'app-tour-credit-dropdown',
  templateUrl: './tour-credit-dropdown.component.html',
  styleUrls: ['./tour-credit-dropdown.component.scss'],
  standalone: true,
  imports: [CommonModule, PriceFormatPipe, ClickOutsideModule]
})
export class TourCreditDropdownComponent {
  @Input() tour: HTTPSearchResultTour;
  @Input() creditTerms: CreditOptions[] = [];
  @Output() onClose = new EventEmitter<void>();

  onClickedOutside() {
    this.onClose.emit();
  }

  getPrice(creditOptions: CreditOptions) {
    return Math.ceil(this.tour.price.value * creditOptions.coefficient);
  }

  getLogoSrc(creditOptions: CreditOptions) {
    switch (creditOptions.bank) {
      case CREDIT_BANKS.HOME_BANK:
        return '/img/logo/logo-home-credit-bank.png';
      case CREDIT_BANKS.KASPI_BANK:
        return '/img/logo/kaspi-logo-red.png';
      case CREDIT_BANKS.ALFA_BANK:
        return '/img/logo/alfa-bank-logo.svg';
      default:
        return '';
    }
  }
}
